import { Component, Input, OnInit, OnDestroy, EventEmitter, Output, ViewChild } from '@angular/core';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { Subscription } from 'rxjs';
import { QuestionBase } from 'core/components/forms/question-base';
import { FiltersService, StoreService } from 'core/services';
import { DynamicFormComponent } from 'core/components/forms';

@Component({
  selector: 'lms-list-filters',
  templateUrl: './list-filters.component.html',
  styleUrls: ['./list-filters.component.scss'],
  animations: [
    trigger('filtersState', [
      state(
        'visible',
        style({
          maxHeight: '10000px',
          opacity: 1,
          margin: '*',
          display: '*'
        })
      ),
      state(
        'hidden',
        style({
          maxHeight: '0',
          opacity: 0,
          margin: 0,
          display: 'none'
        })
      ),
      transition('hidden => visible', animate('300ms ease-in-out')),
      transition('visible => hidden', [style({ margin: '*' }), animate('300ms ease-in-out')])
    ])
  ]
})
export class ListFiltersComponent implements OnInit, OnDestroy {
  @Input() listId: string;
  @Input() filtersService: FiltersService;
  @Input() options: any;
  @Input() visible: boolean = false;
  @Input() hideClose: boolean = false;
  @Output() filter = new EventEmitter<Object>();
  @ViewChild('filtersForm', { static: false }) public filtersForm: DynamicFormComponent;
  filtersQuestions: QuestionBase<any>[] = [];
  filters: any;
  listSubscription: Subscription;
  listFilters: any;

  constructor() {}

  public ngOnInit(): void {
    if (this.filtersService) {
      const scheme = this.options && this.options.scheme;
      const filterName = this.options && this.options.filterName;
      this.filters = this.filtersService.createFilters({ filterName, scheme });
      this.filtersQuestions = Object.values(this.filters)
        .filter((filter) => !!filter)
        .map((filter) => filter['question']);
    }
    this.listSubscription = StoreService.get(this.listId).subscribe((data) => {
      if (data && data.filters) {
        this.listFilters = data.filters;
      }
    });
  }

  ngOnDestroy() {
    if (this.listSubscription) {
      this.listSubscription.unsubscribe();
    }
  }

  applyFilters(values) {
    // Filter question key must be the same as filter name for this to work!
    const $filter = this.filtersService.buildFilterString(values, this.filters);
    const filters = new Map<string, string>(this.listFilters);
    filters.set('$filter', $filter);
    StoreService.merge(this.listId, { filters, page: 1, active: true });
    this.filter.emit(filters);
  }

  public toggleVisible(): void {
    this.visible = !this.visible;
  }
}
